import React, { useState } from "react";
import T from '../../components/common/T';
import api from "../../api/axiosConfig";
import { toast } from "react-toastify";

export default function SetBudgetModal({ isOpen, onClose, availableProjects, onSuccess }) {
  const [formData, setFormData] = useState({ projectId: "", totalBudget: "", notes: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/budgets', formData); 

      toast.success("Budget frozen and active.");
      onSuccess();
      onClose();
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.error || "Error setting budget");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
        <h2 className="text-base font-bold text-gray-800 mb-4"><T>Initialize Project Budget</T></h2>
        <p className="text-sm text-gray-500 mb-6 bg-yellow-50 p-3 rounded border border-yellow-200">
          ⚠️ <strong><T>Warning:</T></strong> You are setting the financial baseline. This can only be changed via Audit Request later.
        </p>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700"><T>Select Project</T></label>
            <select 
              className="w-full border rounded p-2 mt-1"
              required
              onChange={e => setFormData({...formData, projectId: e.target.value})}
            >
              <option value=""><T>-- Choose Project --</T></option>
              {availableProjects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700"><T>Total Approved Limit (₹)</T></label>
            <input 
              type="number" 
              className="w-full border rounded p-2 mt-1 font-mono"
              placeholder="0.00"
              required
              onChange={e => setFormData({...formData, totalBudget: e.target.value})}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700"><T>Initial Notes</T></label>
            <textarea 
              className="w-full border rounded p-2 mt-1" 
              rows="2"
              onChange={e => setFormData({...formData, notes: e.target.value})}
            ></textarea>
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <button type="button" onClick={onClose} className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"><T>Cancel</T></button>
            <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"><T>Confirm Baseline</T></button>
          </div>
        </form>
      </div>
    </div>
  );
}